import styled from 'styled-components';

const ContextualBiddingSectionStyle = styled.div`
  .contextualBiddingSection {
    &__toast {
      margin-bottom: 24px;
    }
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &TitleSection {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding-bottom: 16px;
      }
      &Title {
        font-size: ${props => props.theme.fontSizeXL};
        color: ${props => props.theme.uiColors.textTitle};
      }
    }

    &__actionsButtons {
      align-items: center;
      display: flex;
      flex-direction: column;
    }

    &__actionSection {
      display: flex;
      justify-content: flex-end;
      gap: var(--spacing-16);
      width: 100%;
    }

    &__contextList {
      background-color: var(--color-sonata-primary-200);
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      gap: var(--spacing-8);
      padding: var(--spacing-16);
      margin-bottom: var(--spacing-16);
      align-items: stretch;

      &--noScenario {
        align-items: center;

        .contextualBiddingSection__actionSection {
          justify-content: center;
          width: auto;
        }
      }
    }

    &__range {
      margin-bottom: var(--spacing-16);
    }
  }
  .contextualBiddingSectionTitle {
    font-family: ${props => props.theme.fontSemiBold};
    font-size: ${props => props.theme.fontSizeL};
    margin-top: 0;
    margin-bottom: ${props => props.theme.fontSizeM};
  }
  .contextualBiddingSectionSubtitle {
    font-family: ${props => props.theme.fontSemiBold};
    font-size: ${props => props.theme.fontSizeM};
    margin-top: 0;
    margin-bottom: ${props => props.theme.fontSizeT};
    color: ${props => props.theme.textColorDark}
  }
`;

export { ContextualBiddingSectionStyle };
